module.exports = __webpack_public_path__ + "static/media/next.fc46a408.svg";